import { render, staticRenderFns } from "./OrganizationNavPanel.vue?vue&type=template&id=1ef76974"
import script from "./OrganizationNavPanel.vue?vue&type=script&lang=ts"
export * from "./OrganizationNavPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports